import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'

export const Modal: ComponentStyleConfig = {
  baseStyle: (props: Dict) => ({
    dialog: {
      backgroundColor: mode(
        'rw1.body.light.clean',
        'rw1.body.dark.clean',
      )(props),
      borderRadius: '3xl',
      padding: '4',
    },
    overlay: {
      opacity: '0.5 !important',
      zIndex: 'modal',
      background: mode('rw1.secondary.light.8', 'rw1.secondary.dark.0')(props),
    },
  }),
}
